require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-this-is-why-learning-rails-is-hard.json") })
        }
      }, "path---blog-this-is-why-learning-rails-is-hard");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-this-is-why-learning-rails-is-hard!./.cache/json/blog-this-is-why-learning-rails-is-hard.json
// module id = 1122
// module chunks = 231608221292675